export default __webpack_public_path__ + "static/media/icon.2d7d1ce9.svg";